import styled from '@emotion/styled';

export const Body4 = styled.p`
  font-family: Mulish-Regular;
  color: ${(props) => props.color};
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.35px;
`;
